import Colors from '@/constants/Colors';
import Button from '@/shared/Button/Button';
import styled from 'styled-components';
const {
  playerControlsThemes: { inverted: controlsTheme },
} = Colors;

export const StyledFullscreenButton = styled(Button)`
  color: ${controlsTheme.buttonsForeground};
  background-color: ${controlsTheme.buttonsBackground};
  border: none;
  border-radius: 4px;
  line-height: 1;

  &:hover {
    color: ${controlsTheme.buttonsForegroundHover};
    background-color: ${controlsTheme.buttonsBackgroundHover};
  }

  &.active {
    background-color: ${controlsTheme.buttonsBackgroundFullscreen};
    height: 40px;
    font-size: 120%;
  }
`;
